import type { HtmlHTMLAttributes } from 'react';

import useGlobalStyles from '@/styles/global.styles';

import useStyles from './BulletedList.styles';

interface BulletedListProps extends HtmlHTMLAttributes<HTMLDivElement> {
  list: string[];
}

export default function BulletedList({ list, ...rest }: BulletedListProps) {
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  return (
    <div {...rest}>
      <ol className={classes.orderedList}>
        {list.map((entry, index) => (
          <li key={entry} className={cx(classes.listItem, globalClasses.h5)}>
            <span className={classes.counter}>{index + 1}</span>
            <span className={classes.text}>{entry}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
